import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import FeedbackForm from "./FeedbackForm";
import { addFeedback } from "../storage/storageProxy";
import { auth } from "../firebase";

const PreviewBanner: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedback, setFeedback] = useState("");

  // Check if we should show the banner
  const isDevMode = import.meta.env.VITE_ENV === "DEV";
  const isPreviewDomain = window.location.hostname === "preview.focusmap.app";

  // Don't render if not in dev/preview mode
  if (!isDevMode && !isPreviewDomain) {
    return null;
  }

  const handleFeedbackSubmit = async () => {
    const user = auth.currentUser;
    if (user && feedback) {
      try {
        await addFeedback(user.email || "", feedback, false);
      } catch (error) {
        console.error("Error submitting feedback:", error);
      }
      setShowFeedbackModal(false);
      setFeedback("");
      alert("Thank you for your feedback!");
    } else {
      alert("Please enter your feedback before submitting.");
    }
  };

  return (
    <>
      <div
        className="preview-banner"
        onClick={() => setShowDialog(true)}
        style={{ cursor: "pointer" }}
        title="Click for more information"
      >
        <span className="preview-banner-text">PREVIEW MODE 👆</span>
      </div>

      <Dialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        header="Preview Mode"
        style={{ width: "500px" }}
        modal
        footer={
          <div>
            <Button
              label="OK"
              icon="pi pi-check"
              onClick={() => setShowDialog(false)}
              autoFocus
            />
          </div>
        }
      >
        <div style={{ lineHeight: "1.6" }}>
          <h3 style={{ marginTop: 0 }}>Welcome to Preview Mode!</h3>

          <p>
            <strong>This is a sneak peek</strong> containing the latest features
            and improvements we're working on in FocusMap.
          </p>

          <h4>What does this mean?</h4>
          <ul>
            <li>
              <strong>Experimental features:</strong> See and test new features
              before they launch
            </li>
            <li>
              <strong>Under development:</strong> Some features may not be fully
              finished yet
            </li>
            <li>
              <strong>Potential bugs:</strong> You may experience errors or
              instability
            </li>
            <li>
              <strong>Your feedback matters:</strong> Help us improve the
              features{" "}
              <Button
                label="Send Feedback"
                icon="pi pi-comment"
                className="p-button-sm p-button-text"
                onClick={() => {
                  setShowDialog(false);
                  setShowFeedbackModal(true);
                }}
                style={{ padding: "0.25rem 0.5rem", verticalAlign: "middle" }}
              />
            </li>
          </ul>

          <p style={{ marginTop: "1rem", fontSize: "0.9em", color: "#666" }}>
            <em>
              Note: Data and settings are stored separately from the production
              version.
            </em>
          </p>
        </div>
      </Dialog>

      {showFeedbackModal && (
        <FeedbackForm
          feedback={feedback}
          setFeedback={setFeedback}
          setShowFeedbackModal={setShowFeedbackModal}
          handleFeedbackSubmit={handleFeedbackSubmit}
        />
      )}
    </>
  );
};

export default PreviewBanner;
